export const AppConfig = {
  title: "Baby Trove - find baby names app",
  ios_download: 'https://apps.apple.com/us/app/babytrove/id6504172784',
  android_download: 'https://play.google.com/store/apps/details?id=com.nimpx.babytrove',
};